import React from 'react'
import ClientPlanPreview from '../../client/ClientPlanPreview'
import V3PlanRouteShell from '../plan/V3PlanRouteShell'

export default function V3ClientPlanPreviewPage() {
  return (
    <V3PlanRouteShell>
      <ClientPlanPreview visualVariant="v3" />
    </V3PlanRouteShell>
  )
}

